import { useApi } from '@/shared/api/http';

import type {
  SignData,
  GetAuthCodeData,
  SignResponse,
} from '@/features/AuthForm/model/types/authForm';

export const useAuthService = () => {
  const api = useApi();

  const sign = async (dataReq: SignData) => api.post<SignResponse>('/auth/', dataReq);

  const getAuthCode = async (
    dataReq: GetAuthCodeData,
    bKeyToken: string | null = null,
  ) => {
    const options = bKeyToken
      ? {
          headers: {
            'X-HASH-KEY': bKeyToken,
          },
        }
      : undefined;

    return api.post<{ message?: string }>('/secret-code/', dataReq, options);
  };

  const logout = async () => api.post<{ message?: string }>('/logout/');

  return {
    sign,
    getAuthCode,
    logout,
  };
};
